// extracted by mini-css-extract-plugin
module.exports = {"mobileWidth":"850px","disabled":"link-module__disabled___1du82"};